export const setImageErrorFallback = (
    event: React.SyntheticEvent<HTMLImageElement, Event>,
    fallbackImageUrl: string,
) => {
    const el = event.currentTarget as HTMLImageElement;
    el.onerror = null;
    el.src = fallbackImageUrl;
};
